import React, { useEffect, useRef, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  useListContext,
  usePermissions,
  useRefresh,
} from 'react-admin';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import CreateIcon from '@material-ui/icons/Create';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import EventIcon from '@material-ui/icons/Event';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import FlagIcon from '@material-ui/icons/Flag';
import GetAppIcon from '@material-ui/icons/GetApp';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PersonIcon from '@material-ui/icons/Person';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import ReplayIcon from '@material-ui/icons/Replay';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SearchIcon from '@material-ui/icons/Search';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import { DialogoConfirmacao } from '../../Components';
import ActionsField, {
  resolverAction,
} from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageTabbedComBuscaPagina from '../../Components/ReactAdmin/List/ListPageTabbedComBuscaPagina';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api, getListAPI } from '../../services';
import { PRIMARY_COLOR } from '../../utils';
import { STATUS_ATIVO } from '../../utils/constants';
import {
  PERMISSAO_TELA_DOCUMENTOS_EXCLUIR,
  PERMISSAO_TELA_DOCUMENTOS_LISTAR,
} from '../../utils/dadosTelas';
import DialogoEvidencias from './DialogoEvidencias';
import DialogoTestemunhas from './DialogoTestemunhas';
import { advancedFilters } from './Filter';
import TrilhaEventos from './TrilhaEventos';

const tabs = [
  {
    id: 'aguardando',
    name: 'Aguardando',
    cor: '#f57c00',
    icon: <ScheduleIcon fontSize="small" />,
    filter: { status: 'pendente' },
  },
  {
    id: 'em_analise',
    name: 'Em análise',
    cor: '#1976d2',
    icon: <SearchIcon fontSize="small" />,
    filter: { status: 'em_analise' },
  },
  {
    id: 'concluidos',
    name: 'Concluídos',
    cor: '#388e3c',
    icon: <CheckCircleOutlineIcon fontSize="small" />,
    filter: { status: ['assinado', 'enviado', 'emitido', 'lido'] },
  },
  {
    id: 'cancelados',
    name: 'Cancelados',
    cor: '#c62828',
    icon: <CancelOutlinedIcon fontSize="small" />,
    filter: { status: ['cancelado', 'rejeitado', 'excluido'] },
  },
];

const textoAcao = {
  assinar: 'Assinar',
  visualizar: 'Visualizar',
  enviar_arquivo: 'Enviar arquivo',
};

export const corStatus = {
  sem_documento: '#9e9e9e',
  pendente: '#f57c00',
  assinado: '#388e3c',
  enviado: '#388e3c',
  emitido: '#1976d2',
  lido: '#388e3c',
  cancelado: '#757575',
  excluido: '#757575',
  em_analise: '#0288d1',
  rejeitado: '#c62828',
};

// O pendente diz o que está sendo esperado, conforme a ação do modelo.
export const rotuloStatus = (r) => {
  if (r.status === 'pendente') {
    const acao = r.modelo && r.modelo.acao;
    if (acao === 'enviar_arquivo') return 'Aguardando arquivo';
    if (acao === 'visualizar') return 'Aguardando leitura';
    if (r.assinaturas) {
      return `Aguardando assinaturas (${
        r.assinaturas.filter((a) => a.assinado_em).length
      }/${r.assinaturas.length})`;
    }
    if (r.forma_assinatura === 'testemunhas') {
      const lista = r.testemunhas || [];
      return `Aguardando testemunhas (${
        lista.filter((t) => t.assinado_em).length
      }/${lista.length})`;
    }
    return 'Aguardando assinatura';
  }
  return (
    {
      sem_documento: 'Sem documento',
      assinado: 'Assinado',
      enviado: 'Arquivo enviado',
      emitido: 'Só leitura',
      lido: 'Lido',
      cancelado: 'Cancelado',
      excluido: 'Excluído',
      em_analise: 'Em análise',
      rejeitado: 'Rejeitado',
    }[r.status] || r.status
  );
};

// O visualizador do navegador mostraria o nome do blob (um código aleatório) na
// barra do topo; escondê-la deixa só o documento, e o título fica no diálogo.
const SEM_BARRA_PDF = '#toolbar=0&navpanes=0';

// Arquivo de documento: PDF ou imagem (JPG/PNG). O tipo vem do servidor no próprio blob;
// sem ele, assume PDF para o navegador não mostrar os bytes como texto.
export const tipoDoBlob = (dados) => dados.type || 'application/pdf';
export const urlDoArquivo = (dados) =>
  URL.createObjectURL(
    dados.type ? dados : new Blob([dados], { type: 'application/pdf' }),
  );
export const extensaoDoTipo = (tipo) =>
  ({ 'image/jpeg': 'jpg', 'image/png': 'png' }[tipo] || 'pdf');

// Celulares (e navegadores sem visualizador de PDF embutido) não mostram o PDF dentro do <iframe>:
// ficam só com um botão "Abrir". Neles, as páginas são desenhadas aqui com o pdf.js, carregado
// só quando preciso. Computador com visualizador embutido continua com o <iframe>.
const PDF_EMBUTIDO =
  typeof navigator !== 'undefined' &&
  navigator.pdfViewerEnabled === true &&
  !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const PdfPaginas = ({ url, titulo }) => {
  const paginas = useRef(null);
  const [estado, setEstado] = useState('carregando');

  useEffect(() => {
    let cancelado = false;
    let pdf = null;
    setEstado('carregando');
    (async () => {
      try {
        const pdfjs = await import('pdfjs-dist/legacy/build/pdf');
        // O worker roda na própria página (sem arquivo extra para servir).
        await import('pdfjs-dist/legacy/build/pdf.worker.entry');
        pdf = await pdfjs.getDocument(url).promise;
        const largura = paginas.current.clientWidth || window.innerWidth;
        const densidade = Math.min(window.devicePixelRatio || 1, 2);
        for (let numero = 1; numero <= pdf.numPages; numero += 1) {
          if (cancelado) return;
          // eslint-disable-next-line no-await-in-loop
          const pagina = await pdf.getPage(numero);
          const escala = largura / pagina.getViewport({ scale: 1 }).width;
          const viewport = pagina.getViewport({ scale: escala * densidade });
          const canvas = window.document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.cssText =
            'width:100%;display:block;margin-bottom:8px;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,0.2)';
          paginas.current.appendChild(canvas);
          // eslint-disable-next-line no-await-in-loop
          await pagina.render({
            canvasContext: canvas.getContext('2d'),
            viewport,
          }).promise;
        }
        if (!cancelado) setEstado('ok');
      } catch (e) {
        if (!cancelado) setEstado('erro');
      }
    })();
    return () => {
      cancelado = true;
      if (pdf) pdf.destroy();
      if (paginas.current) paginas.current.innerHTML = '';
    };
  }, [url]);

  return (
    <div
      style={{
        flex: 1,
        overflow: 'auto',
        backgroundColor: '#e2e8f0',
        padding: 8,
      }}
    >
      {estado === 'carregando' && (
        <Typography variant="body2" align="center" style={{ padding: 16 }}>
          Carregando o documento...
        </Typography>
      )}
      {estado === 'erro' && (
        <Box textAlign="center" p={2}>
          <Typography variant="body2" gutterBottom>
            Não foi possível mostrar o documento aqui.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir {titulo}
          </Button>
        </Box>
      )}
      <div ref={paginas} />
    </div>
  );
};

// PDF no visualizador do navegador; imagem ajustada à área, sem cortar.
export const VisualizadorArquivo = ({ url, tipo, titulo = 'Documento' }) => {
  // Tela estreita (celular, ou janela de celular no computador, em que o navegador ainda diz ser
  // computador): também usa o desenho próprio, porque o <iframe> de PDF costuma ser bloqueado.
  const estreita = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  if ((tipo || '').startsWith('image/')) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          overflow: 'auto',
          backgroundColor: '#f1f5f9',
        }}
      >
        <img
          src={url}
          alt={titulo}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            margin: 'auto',
          }}
        />
      </div>
    );
  }
  if (!PDF_EMBUTIDO || estreita)
    return <PdfPaginas url={url} titulo={titulo} />;
  return (
    <iframe
      title={titulo}
      src={`${url}${SEM_BARRA_PDF}`}
      style={{ border: 0, width: '100%', flex: 1 }}
    />
  );
};

// Mensagem do servidor (ex.: "Dado ausente: CPF.") ou a padrão.
function mensagemDaResposta(e, padrao) {
  return e.response && e.response.data && e.response.data.message
    ? e.response.data.message
    : padrao;
}

// Com responseType 'blob' o corpo do erro (JSON) também chega como Blob.
async function mensagemDoErro(e) {
  try {
    const corpo = JSON.parse(await e.response.data.text());
    return corpo.message || 'Erro ao abrir o PDF.';
  } catch (erro) {
    return 'Erro ao abrir o PDF.';
  }
}

// O react-admin lembra os filtros da última visita na sessão. Ao abrir a tela
// o status volta para "pendente" (os demais filtros são mantidos).
const StatusInicial = () => {
  const { filterValues, setFilters, displayedFilters } = useListContext();
  useEffect(() => {
    if (filterValues.status !== 'pendente') {
      setFilters({ ...filterValues, status: 'pendente' }, displayedFilters);
    }
  }, []);
  return null;
};

// Colunas do resumo por modelo = abas da tela (mesmo filtro de status).
const COLUNAS_RESUMO = [
  {
    campo: 'aguardando',
    titulo: 'Aguardando',
    status: 'pendente',
    cor: '#f57c00',
  },
  {
    campo: 'em_analise',
    titulo: 'Em análise',
    status: 'em_analise',
    cor: '#0288d1',
  },
  {
    campo: 'concluidos',
    titulo: 'Concluídos',
    status: ['assinado', 'enviado', 'emitido', 'lido'],
    cor: '#388e3c',
  },
  {
    campo: 'encerrados',
    titulo: 'Cancelados/Rejeitados',
    status: ['cancelado', 'rejeitado', 'excluido'],
    cor: '#c62828',
  },
];

// Uma linha por modelo (em vez de uma por colaborador). Clicar num número aplica
// o filtro de modelo e de status e mostra a lista daquela aba.
const ResumoPorModelo = ({ open, onClose }) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const { filterValues, setFilters, displayedFilters } = useListContext();
  const { enqueueSnackbar } = useSnackbar();
  const [linhas, setLinhas] = useState(null);

  useEffect(() => {
    if (!open) return;
    setLinhas(null);
    api
      .get('/documentos/por-modelo')
      .then((response) => setLinhas(response.data.data))
      .catch((e) => {
        enqueueSnackbar(mensagemDaResposta(e, 'Erro ao carregar o resumo.'), {
          variant: 'error',
        });
        onClose();
      });
  }, [open]);

  function filtrar(linha, coluna) {
    setFilters(
      {
        ...filterValues,
        modelo_documento_id: linha.id,
        status: coluna.status,
      },
      { ...displayedFilters, modelo_documento_id: true },
    );
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={celular}
      maxWidth="md"
    >
      <Box
        display="flex"
        alignItems="center"
        px={2}
        py={1}
        style={{ gap: 8, backgroundColor: PRIMARY_COLOR, color: 'white' }}
      >
        <ViewListOutlinedIcon />
        <Typography variant="subtitle1" style={{ fontWeight: 600, flex: 1 }}>
          Resumo por modelo
        </Typography>
        <IconButton
          size="small"
          aria-label="Fechar"
          style={{ color: 'white' }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Toque em um número para ver os documentos daquele grupo.
        </Typography>
        {linhas === null && <LinearProgress style={{ marginTop: 8 }} />}
        {linhas !== null && linhas.length === 0 && (
          <Typography variant="body2" style={{ marginTop: 8 }}>
            Nenhum documento gerado.
          </Typography>
        )}
        {/* Celular: um cartão por modelo, com os quatro totais em quadros coloridos. */}
        {celular && linhas !== null && linhas.length > 0 && (
          <Box mt={1.5}>
            {linhas.map((linha) => (
              <Paper
                key={linha.id}
                variant="outlined"
                style={{ padding: 12, marginBottom: 12, borderRadius: 12 }}
              >
                <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                  {linha.nome}
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  style={{
                    fontWeight: 600,
                    color: COR_ACAO_CARTAO[linha.acao] || '#555',
                  }}
                >
                  {textoAcao[linha.acao] || '—'}
                </Typography>
                <Box
                  mt={1.5}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 8,
                  }}
                >
                  {COLUNAS_RESUMO.map((coluna) => {
                    const total = linha[coluna.campo];
                    return (
                      <button
                        key={coluna.campo}
                        type="button"
                        disabled={!(total > 0)}
                        onClick={() => filtrar(linha, coluna)}
                        style={{
                          textAlign: 'left',
                          padding: '8px 12px',
                          borderRadius: 10,
                          border: `1px solid ${coluna.cor}66`,
                          backgroundColor: `${coluna.cor}1a`,
                          color: coluna.cor,
                          font: 'inherit',
                          cursor: total > 0 ? 'pointer' : 'default',
                          opacity: total > 0 ? 1 : 0.45,
                        }}
                      >
                        <span
                          style={{
                            display: 'block',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                          }}
                        >
                          {coluna.titulo}
                        </span>
                        <span
                          style={{
                            display: 'block',
                            fontSize: '1.25rem',
                            fontWeight: 700,
                          }}
                        >
                          {total > 0 ? total : '—'}
                        </span>
                      </button>
                    );
                  })}
                </Box>
              </Paper>
            ))}
          </Box>
        )}
        {!celular && linhas !== null && linhas.length > 0 && (
          <Table size="small" style={{ marginTop: 8 }}>
            <TableHead>
              <TableRow>
                <TableCell>Modelo</TableCell>
                {COLUNAS_RESUMO.map((coluna) => (
                  <TableCell
                    key={coluna.campo}
                    align="center"
                    style={{ color: coluna.cor, fontWeight: 700 }}
                  >
                    {coluna.titulo}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {linhas.map((linha) => (
                <TableRow key={linha.id} hover>
                  <TableCell>
                    <span style={{ fontWeight: 600 }}>{linha.nome}</span>
                    <Typography
                      variant="caption"
                      display="block"
                      style={{
                        fontWeight: 600,
                        color: COR_ACAO_CARTAO[linha.acao] || '#555',
                      }}
                    >
                      {textoAcao[linha.acao] || '—'}
                    </Typography>
                  </TableCell>
                  {COLUNAS_RESUMO.map((coluna) => (
                    <TableCell key={coluna.campo} align="center">
                      {linha[coluna.campo] > 0 ? (
                        <Chip
                          size="small"
                          clickable
                          label={linha[coluna.campo]}
                          onClick={() => filtrar(linha, coluna)}
                          style={{
                            fontWeight: 700,
                            color: coluna.cor,
                            backgroundColor: `${coluna.cor}1a`,
                            border: `1px solid ${coluna.cor}66`,
                          }}
                        />
                      ) : (
                        '—'
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

// JSON vindo do banco (variáveis do modelo, valores informados): inválido não quebra a tela.
const lerJson = (texto, padrao) => {
  try {
    return JSON.parse(texto || JSON.stringify(padrao));
  } catch (e) {
    return padrao;
  }
};

export const formatarDataHora = (data) =>
  data ? new Date(data).toLocaleString('pt-BR') : '—';

// 2026-10 -> 10/2026; 2026 -> 2026; sem competência -> —.
export const formatarCompetencia = (c) => {
  if (!c) return '—';
  return /^\d{4}-\d{2}$/.test(c) ? `${c.slice(5)}/${c.slice(0, 4)}` : c;
};

export const Campo = ({ icone, rotulo, children }) => (
  <Box display="flex" alignItems="flex-start" style={{ gap: 12 }}>
    <Box color="text.secondary" pt={0.25}>
      {icone}
    </Box>
    <div style={{ minWidth: 0 }}>
      <Typography variant="caption" color="textSecondary" display="block">
        {rotulo}
      </Typography>
      <Typography variant="body2" style={{ fontWeight: 500 }}>
        {children || '—'}
      </Typography>
    </div>
  </Box>
);

// Bloco de detalhes com título próprio e borda, para separar os assuntos.
export const BlocoDetalhe = ({ titulo, children }) => (
  <Paper variant="outlined" style={{ marginTop: 16, overflow: 'hidden' }}>
    <Box
      px={2}
      py={0.75}
      bgcolor="action.hover"
      borderBottom={1}
      borderColor="divider"
    >
      <Typography
        variant="overline"
        color="textSecondary"
        style={{ fontWeight: 700, letterSpacing: 1 }}
      >
        {titulo}
      </Typography>
    </Box>
    <Box p={2}>{children}</Box>
  </Paper>
);

export const gradeCampos = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 20,
};

// `onVisualizarPdf(documento)` abre o PDF no visualizador de quem usa o diálogo;
// `comTrilha` mostra a aba de trilha de eventos (só para o RH).
export const DialogoDetalhes = ({
  documento,
  onClose,
  onVisualizarPdf,
  onVisualizarArquivo,
  comTrilha = true,
}) => {
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const [aba, setAba] = useState('detalhes');
  // Mantém o último documento no conteúdo durante a animação de fechamento.
  const d = documento || {};
  const modelo = d.modelo || {};

  function fechar() {
    setAba('detalhes');
    onClose();
  }

  return (
    <Dialog
      open={Boolean(documento)}
      onClose={fechar}
      fullWidth
      fullScreen={celular}
      maxWidth="sm"
    >
      <Box
        display="flex"
        alignItems="center"
        px={2}
        py={1}
        style={{
          gap: 12,
          backgroundColor: PRIMARY_COLOR,
          color: 'white',
        }}
      >
        <Typography variant="subtitle1" noWrap style={{ fontWeight: 600 }}>
          Documento do colaborador
        </Typography>
        <Box flex={1} />
        <IconButton size="small" onClick={fechar} style={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </Box>
      {comTrilha && (
        <Tabs
          value={aba}
          onChange={(event, valor) => setAba(valor)}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Detalhes" value="detalhes" />
          {d.status === 'assinado' && (
            <Tab label="Evidências" value="evidencias" />
          )}
          <Tab label="Trilha" value="trilha" />
        </Tabs>
      )}
      <DialogContent>
        {aba === 'evidencias' ? (
          <DialogoEvidencias
            documentoId={d.id}
            onErro={() => setAba('detalhes')}
          />
        ) : aba === 'trilha' ? (
          <TrilhaEventos documentoId={d.id} onErro={() => setAba('detalhes')} />
        ) : (
          <>
            <BlocoDetalhe titulo="Documento">
              <Box style={gradeCampos}>
                <Campo
                  icone={<DescriptionIcon fontSize="small" />}
                  rotulo="Modelo"
                >
                  {modelo.nome}
                </Campo>
                <Campo icone={<FlagIcon fontSize="small" />} rotulo="Situação">
                  <Chip
                    size="small"
                    label={rotuloStatus(d)}
                    style={{
                      backgroundColor: corStatus[d.status] || '#9e9e9e',
                      color: 'white',
                    }}
                  />
                  {legendaStatus(d) && (
                    <Typography
                      variant="caption"
                      display="block"
                      color="textSecondary"
                    >
                      {legendaStatus(d)}
                    </Typography>
                  )}
                </Campo>
                <Campo
                  icone={<PersonIcon fontSize="small" />}
                  rotulo="Colaborador"
                >
                  {d.colaborador && d.colaborador.nome}
                </Campo>
                <Campo
                  icone={<AssignmentIcon fontSize="small" />}
                  rotulo="Ação"
                >
                  {textoAcao[modelo.acao]}
                </Campo>
                <Campo
                  icone={<CalendarTodayIcon fontSize="small" />}
                  rotulo="Competência"
                >
                  {formatarCompetencia(d.competencia)}
                </Campo>
                <Campo
                  icone={<EventIcon fontSize="small" />}
                  rotulo="Criado em"
                >
                  {formatarDataHora(d.created_at)}
                </Campo>
              </Box>
              {modelo.descricao && (
                <Box mt={2}>
                  <Divider />
                  <Box mt={2}>
                    <Campo
                      icone={<InfoOutlinedIcon fontSize="small" />}
                      rotulo="Instrução ao colaborador"
                    >
                      {modelo.descricao}
                    </Campo>
                  </Box>
                </Box>
              )}
            </BlocoDetalhe>
            {modelo.acao === 'assinar' && (
              <BlocoDetalhe titulo="Assinatura">
                <Box style={gradeCampos}>
                  <Campo
                    icone={<CreateIcon fontSize="small" />}
                    rotulo="Assinante"
                  >
                    {d.userAssinante &&
                      `${
                        (d.userAssinante.colaborador &&
                          d.userAssinante.colaborador.nome) ||
                        d.userAssinante.username
                      }${
                        d.status === 'pendente' &&
                        d.userAssinante.status !== STATUS_ATIVO
                          ? ' (inativo)'
                          : ''
                      }`}
                  </Campo>
                  <Campo
                    icone={<EventAvailableIcon fontSize="small" />}
                    rotulo="Assinado em"
                  >
                    {d.assinatura && formatarDataHora(d.assinatura.assinado_em)}
                  </Campo>
                </Box>
              </BlocoDetalhe>
            )}
            {d.assinaturas && (
              <BlocoDetalhe titulo="Assinaturas">
                {d.forma_assinatura === 'testemunhas' && (
                  <Campo
                    icone={<InfoOutlinedIcon fontSize="small" />}
                    rotulo="Motivo da assinatura por testemunhas"
                  >
                    {d.motivo_forma_assinatura}
                  </Campo>
                )}
                {d.assinaturas.map((a) => (
                  <Box key={a.user_id} mt={2}>
                    <Campo
                      icone={<CreateIcon fontSize="small" />}
                      rotulo={
                        a.papel === 'testemunha'
                          ? 'Testemunha'
                          : `Assinatura ${a.ordem}`
                      }
                    >
                      {`${a.nome} · ${
                        a.assinado_em
                          ? `assinou em ${formatarDataHora(a.assinado_em)}`
                          : 'ainda não assinou'
                      }`}
                    </Campo>
                  </Box>
                ))}
              </BlocoDetalhe>
            )}
            {d.forma_assinatura === 'testemunhas' && !d.assinaturas && (
              <BlocoDetalhe titulo="Assinatura por testemunhas">
                <Campo
                  icone={<InfoOutlinedIcon fontSize="small" />}
                  rotulo="Motivo"
                >
                  {d.motivo_forma_assinatura}
                </Campo>
                {(d.testemunhas || []).map((t, indice) => (
                  <Box key={t.user_id} mt={2}>
                    <Campo
                      icone={<CreateIcon fontSize="small" />}
                      rotulo={`Testemunha ${indice + 1}`}
                    >
                      {`${t.nome} · ${
                        t.assinado_em
                          ? `assinou em ${formatarDataHora(t.assinado_em)}`
                          : 'ainda não assinou'
                      }`}
                    </Campo>
                  </Box>
                ))}
              </BlocoDetalhe>
            )}
            {modelo.acao === 'visualizar' && (
              <BlocoDetalhe titulo="Leitura">
                <Campo
                  icone={<EventAvailableIcon fontSize="small" />}
                  rotulo="Lido em"
                >
                  {d.lido_em ? formatarDataHora(d.lido_em) : 'Ainda não lido'}
                </Campo>
              </BlocoDetalhe>
            )}
            {modelo.acao === 'enviar_arquivo' && (
              <BlocoDetalhe titulo="Arquivo do colaborador">
                <Campo
                  icone={<AttachFileIcon fontSize="small" />}
                  rotulo="Enviado em"
                >
                  {Boolean(d.tem_arquivo_enviado) &&
                    formatarDataHora(d.data_envio)}
                </Campo>
                {d.data_documento && (
                  <Box mt={2}>
                    <Campo
                      icone={<EventIcon fontSize="small" />}
                      rotulo="Data do documento"
                    >
                      {String(d.data_documento)
                        .slice(0, 10)
                        .split('-')
                        .reverse()
                        .join('/')}
                    </Campo>
                  </Box>
                )}
                {d.observacao && (
                  <Box mt={2}>
                    <Campo
                      icone={<InfoOutlinedIcon fontSize="small" />}
                      rotulo="Observação do colaborador"
                    >
                      <span style={{ whiteSpace: 'pre-wrap' }}>
                        {d.observacao}
                      </span>
                    </Campo>
                  </Box>
                )}
                {d.motivo_rejeicao && (
                  <Box mt={2}>
                    <Campo
                      icone={<HighlightOffIcon fontSize="small" />}
                      rotulo="Motivo da rejeição"
                    >
                      {d.motivo_rejeicao}
                    </Campo>
                  </Box>
                )}
                {Boolean(d.tem_arquivo_enviado) && (
                  <Box mt={2}>
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => onVisualizarArquivo(d)}
                    >
                      Visualizar arquivo enviado
                    </Button>
                  </Box>
                )}
              </BlocoDetalhe>
            )}
            {d.valores_variaveis && (
              <BlocoDetalhe titulo="Valores informados">
                {Object.entries(lerJson(d.valores_variaveis, {})).map(
                  ([chave, valor]) => {
                    const variavel = lerJson(
                      d.modelo && d.modelo.variaveis_personalizadas,
                      [],
                    ).find((item) => item.chave === chave);
                    return (
                      <Box key={chave} mb={1}>
                        <Campo
                          icone={<InfoOutlinedIcon fontSize="small" />}
                          rotulo={variavel ? variavel.rotulo : chave}
                        >
                          <span style={{ whiteSpace: 'pre-wrap' }}>
                            {valor}
                          </span>
                        </Campo>
                      </Box>
                    );
                  },
                )}
              </BlocoDetalhe>
            )}
            {Boolean(d.tem_pdf) && (
              <BlocoDetalhe titulo="PDF">
                {Boolean(d.pdf_substituido) && (
                  <Box mb={2}>
                    <Campo
                      icone={<PictureAsPdfIcon fontSize="small" />}
                      rotulo="Origem"
                    >
                      Substituído (diferente do modelo)
                    </Campo>
                  </Box>
                )}
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  startIcon={<VisibilityIcon />}
                  onClick={() => onVisualizarPdf(d)}
                >
                  Visualizar PDF
                </Button>
              </BlocoDetalhe>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

const renderColaborador = (r) => (r.colaborador ? r.colaborador.nome : '—');

const renderDocumento = (r) => (
  <>
    {r.modelo ? r.modelo.nome : '—'}
    <Typography variant="caption" display="block" color="textSecondary">
      {(r.modelo && textoAcao[r.modelo.acao]) || '—'}
    </Typography>
  </>
);

const COR_ASSINADO = '#2e7d32';
const COR_PENDENTE = '#e65100';

// Uma assinatura da lista: ícone do estado (assinou / falta), nome na cor do estado e, nas
// testemunhas, a etiqueta "Testemunha".
const LinhaAssinatura = ({ ordem, nome, assinadoEm, testemunha }) => {
  const cor = assinadoEm ? COR_ASSINADO : COR_PENDENTE;
  const Icone = assinadoEm ? CheckCircleOutlineIcon : ScheduleIcon;
  return (
    <Typography
      variant="caption"
      component="div"
      style={{
        color: cor,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <Tooltip title={assinadoEm ? 'Assinou' : 'Aguardando assinatura'}>
        <Icone style={{ fontSize: 16 }} />
      </Tooltip>
      {ordem ? `${ordem}. ${nome}` : nome}
      {testemunha && (
        <Chip
          size="small"
          variant="outlined"
          icon={<GroupAddIcon style={{ fontSize: 13, color: 'inherit' }} />}
          label="Testemunha"
          style={{ height: 18, fontSize: '0.65rem', color: 'inherit' }}
        />
      )}
    </Typography>
  );
};

// `opcoes.semData`: sem a linha com a data/hora da assinatura (cartão do celular).
export const renderAssinatura = (r, opcoes = {}) => {
  if (r.assinaturas) {
    return r.assinaturas.map((a) => (
      <LinhaAssinatura
        key={a.user_id}
        ordem={a.ordem}
        nome={a.nome}
        assinadoEm={a.assinado_em}
        testemunha={a.papel === 'testemunha'}
      />
    ));
  }
  if (r.forma_assinatura === 'testemunhas') {
    return (r.testemunhas || []).map((t) => (
      <LinhaAssinatura
        key={t.user_id}
        nome={t.nome}
        assinadoEm={t.assinado_em}
        testemunha
      />
    ));
  }
  if (!r.userAssinante) return '—';
  const inativo =
    r.status === 'pendente' && r.userAssinante.status !== STATUS_ATIVO;
  const nomeAssinante =
    (r.userAssinante.colaborador && r.userAssinante.colaborador.nome) ||
    r.userAssinante.username;
  return (
    <>
      {r.assinatura || r.status === 'pendente' ? (
        <span
          style={{
            color: r.assinatura ? COR_ASSINADO : COR_PENDENTE,
            fontWeight: 600,
          }}
        >
          {nomeAssinante}
        </span>
      ) : (
        nomeAssinante
      )}
      {inativo && (
        <Typography
          variant="caption"
          display="block"
          style={{ color: '#e65100' }}
        >
          assinante inativo
        </Typography>
      )}
      {r.assinatura && !opcoes.semData && (
        <Typography variant="caption" display="block" color="textSecondary">
          {new Date(r.assinatura.assinado_em).toLocaleString('pt-BR')}
        </Typography>
      )}
    </>
  );
};

const renderCriadoEm = (r) => formatarDataHora(r.created_at);

const renderCompetencia = (r) => formatarCompetencia(r.competencia);

// Data da última assinatura (a única, ou a mais recente quando há várias).
const dataAssinatura = (r) =>
  (r.assinaturas
    ? r.assinaturas.map((a) => a.assinado_em)
    : [r.assinatura && r.assinatura.assinado_em]
  )
    .filter(Boolean)
    .sort()
    .pop();

// Selo mostrado só na tela (lista e visualizador); o PDF não é alterado.
const textoSelo = (r) => {
  const data = dataAssinatura(r);
  const total = r.assinaturas ? r.assinaturas.length : 0;
  return [
    total > 1 ? `Assinado por ${total} pessoas` : 'Assinado',
    data && formatarDataHora(data),
  ]
    .filter(Boolean)
    .join(' · ');
};

// Quando o documento chegou à situação atual ("Lido em 02/11/2026 14:10"); pendente não tem.
export const legendaStatus = (r) => {
  const quando = {
    assinado: dataAssinatura(r),
    lido: r.lido_em,
    enviado: r.data_envio,
    em_analise: r.data_envio,
    rejeitado: r.analisado_em,
    cancelado: r.updated_at,
    excluido: r.updated_at,
  }[r.status];
  const rotulo = {
    assinado: 'Assinado',
    lido: 'Lido',
    enviado: 'Enviado',
    em_analise: 'Enviado',
    rejeitado: 'Rejeitado',
    cancelado: 'Cancelado',
    excluido: 'Excluído',
  }[r.status];
  return quando ? `${rotulo} em ${formatarDataHora(quando)}` : null;
};

// `opcoes.semLegenda`: só a etiqueta do status, sem a data embaixo (cartão do celular).
const renderStatus = (r, opcoes = {}) => (
  <>
    <Chip
      size="small"
      icon={
        r.status === 'assinado' ? (
          <VerifiedUserIcon style={{ color: 'white' }} />
        ) : undefined
      }
      label={rotuloStatus(r)}
      style={{
        backgroundColor: corStatus[r.status] || '#9e9e9e',
        color: 'white',
      }}
    />
    {legendaStatus(r) && !opcoes.semLegenda && (
      <Typography variant="caption" display="block" color="textSecondary">
        {legendaStatus(r)}
      </Typography>
    )}
  </>
);

// Tabela: o status e, embaixo dele, todos os assinantes (sem coluna própria para eles).
const renderStatusComAssinantes = (r) => {
  // Sem a data e a hora da assinatura (nem a legenda "Assinado em…" nem a linha do assinante).
  const assinantes = renderAssinatura(r, { semData: true });
  return (
    <>
      {renderStatus(r, { semLegenda: r.status === 'assinado' })}
      {assinantes !== '—' && <div style={{ marginTop: 6 }}>{assinantes}</div>}
    </>
  );
};

export {
  renderStatusComAssinantes,
  renderColaborador,
  renderCompetencia,
  renderCriadoEm,
  renderDocumento,
  renderStatus,
};

// Ações de um documento (detalhes, PDF, aprovar/rejeitar, reemitir,
// testemunhas, cancelar e excluir) e os diálogos que elas abrem. Usado pela tela
// Documentos e pela aba Documentos do detalhe do modelo; `aoAtualizar` é chamado depois
// de qualquer ação que altere um documento.
export const useAcoesDocumentos = (aoAtualizar) => {
  const { enqueueSnackbar } = useSnackbar();
  const celularAcoes = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const { permissions } = usePermissions();
  const podeExcluir = Boolean(
    permissions && permissions[PERMISSAO_TELA_DOCUMENTOS_EXCLUIR],
  );
  const refDialogoConfirmacao = useRef(null);
  const [pdf, setPdf] = useState({ open: false, url: null });
  const [rejeitando, setRejeitando] = useState(null);
  const [motivo, setMotivo] = useState('');
  const [detalhes, setDetalhes] = useState(null);
  const [testemunhasDoc, setTestemunhasDoc] = useState(null);
  const refSubstituir = useRef(null);
  const alvoSubstituir = useRef(null);

  // Documento de "um arquivo por colaborador": troca o arquivo enquanto estiver pendente e sem
  // assinatura (corrige um envio errado).
  async function arquivoSubstituto(event) {
    const [arquivo] = event.target.files;
    // Permite escolher de novo o mesmo arquivo depois de uma recusa.
    event.target.value = '';
    const documento = alvoSubstituir.current;
    if (!arquivo || !documento) return;
    if (
      !['application/pdf', 'image/jpeg', 'image/png'].includes(arquivo.type) ||
      arquivo.size > 10 * 1024 * 1024
    ) {
      enqueueSnackbar('Selecione um PDF ou uma imagem JPG/PNG de até 10 MB.', {
        variant: 'error',
      });
      return;
    }
    try {
      const formData = new FormData();
      formData.append('file', arquivo);
      await api.put(
        `/documentos/${documento.id}/substituir-arquivo`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      enqueueSnackbar('Arquivo trocado.', { variant: 'success' });
      aoAtualizar();
    } catch (e) {
      enqueueSnackbar(await mensagemDoErro(e), { variant: 'error' });
    }
  }

  async function handleVisualizar(documento, rota = 'pdf') {
    const {
      id,
      modelo,
      colaborador,
      competencia,
      created_at: criadoEm,
    } = documento;
    try {
      const response = await api.get(`/documentos/${id}/${rota}`, {
        responseType: 'blob',
      });
      setPdf({
        open: true,
        selo:
          documento.status === 'assinado' && rota === 'pdf'
            ? textoSelo(documento)
            : null,
        url: urlDoArquivo(response.data),
        tipo: tipoDoBlob(response.data),
        titulo: [modelo && modelo.nome, colaborador && colaborador.nome]
          .filter(Boolean)
          .join(' · '),
        // Nome do arquivo baixado: documento - colaborador - competência (a
        // barra da competência mensal não vale em nome de arquivo).
        arquivo: [
          modelo && modelo.nome,
          colaborador && colaborador.nome,
          competencia &&
            (/^\d{4}-\d{2}$/.test(competencia)
              ? `${competencia.slice(5)}-${competencia.slice(0, 4)}`
              : competencia),
        ]
          .filter(Boolean)
          .join(' - '),
        data: [
          `Criado em ${formatarDataHora(criadoEm)}`,
          competencia &&
            `Competência ${
              /^\d{4}-\d{2}$/.test(competencia)
                ? `${competencia.slice(5)}/${competencia.slice(0, 4)}`
                : competencia
            }`,
        ]
          .filter(Boolean)
          .join(' · '),
      });
    } catch (e) {
      enqueueSnackbar(await mensagemDoErro(e), { variant: 'error' });
    }
  }

  // Baixa o arquivo que já está aberto no visualizador.
  function baixarPdfAberto() {
    const link = document.createElement('a');
    link.href = pdf.url;
    link.download = `${(pdf.arquivo || 'documento').replace(
      /[\\/:*?"<>|]/g,
      '-',
    )}.${extensaoDoTipo(pdf.tipo)}`;
    link.click();
  }

  async function executar(id, acao, padrao, dados) {
    try {
      const response = await api.put(`/documentos/${id}/${acao}`, dados);
      enqueueSnackbar(response.data.message, { variant: 'success' });
      aoAtualizar();
    } catch (e) {
      enqueueSnackbar(mensagemDaResposta(e, padrao), { variant: 'error' });
    }
  }

  function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        return executar(id, 'cancelar', 'Erro ao cancelar o documento.');
      case 2:
        return executar(id, 'reemitir', 'Erro ao reemitir o documento.');
      case 3:
        return executar(id, 'aprovar', 'Erro ao aprovar o arquivo.');
      case 4:
        return executar(id, 'cancelar', 'Erro ao excluir o documento.', {
          excluir: true,
        });
      default:
    }
  }

  function handleCancelar(id) {
    refDialogoConfirmacao.current.handleOpen(
      'CANCELAR DOCUMENTO',
      'Cancelar este documento? A ação é definitiva: o mesmo modelo, colaborador e período não poderá ser gerado de novo.',
      { id, codigo: 1 },
    );
  }

  function handleExcluir(id) {
    refDialogoConfirmacao.current.handleOpen(
      'EXCLUIR DOCUMENTO',
      'Excluir este documento? Ele deixa de aparecer para o colaborador. A assinatura e o histórico continuam registrados e visíveis ao RH, na aba Cancelados.',
      { id, codigo: 4 },
    );
  }

  function handleAprovar(id) {
    refDialogoConfirmacao.current.handleOpen(
      'APROVAR ARQUIVO',
      'Aprovar o arquivo enviado? O documento passa para Concluídos.',
      { id, codigo: 3 },
    );
  }

  async function rejeitar() {
    try {
      const response = await api.put(`/documentos/${rejeitando.id}/rejeitar`, {
        motivo,
      });
      enqueueSnackbar(response.data.message, { variant: 'success' });
      setRejeitando(null);
      aoAtualizar();
    } catch (e) {
      enqueueSnackbar(mensagemDaResposta(e, 'Erro ao rejeitar o arquivo.'), {
        variant: 'error',
      });
    }
  }

  function handleReemitir(id) {
    refDialogoConfirmacao.current.handleOpen(
      'REEMITIR DOCUMENTO',
      'Refazer o PDF com o modelo e o cadastro atuais? O PDF anterior deixa de ser usado neste documento.',
      { id, codigo: 2 },
    );
  }

  function handleFechar() {
    if (pdf.url) URL.revokeObjectURL(pdf.url);
    setPdf({ open: false, url: null });
  }

  const acoes = [
    {
      title: 'Detalhes',
      // No cartão do celular esta ação aparece sempre, entre os botões principais.
      sempreNoCartao: true,
      icon: <InfoOutlinedIcon />,
      onClick: (r) => setDetalhes(r),
    },
    // Todas as ações aparecem em todas as linhas (as que não se aplicam ficam
    // desabilitadas), para a coluna não ficar desalinhada de uma linha à outra.
    {
      rotuloCurto: 'Aprovar',
      title: 'Aprovar arquivo (abra o arquivo antes)',
      icon: <CheckCircleOutlineIcon />,
      // Só aparece quando há arquivo em análise (em vez de ficar desabilitado).
      show: (r) => r.status === 'em_analise',
      onClick: (r) => handleAprovar(r.id),
      propsButton: { color: 'primary' },
    },
    {
      title: 'Rejeitar arquivo',
      icon: <HighlightOffIcon />,
      show: (r) => r.status === 'em_analise',
      onClick: (r) => {
        setMotivo('');
        setRejeitando(r);
      },
    },
    {
      title: 'Reemitir',
      icon: <ReplayIcon />,
      disabled: (r) =>
        !(
          r.status === 'pendente' &&
          Boolean(r.tem_pdf) &&
          r.forma_assinatura !== 'testemunhas' &&
          !r.assinaturas
        ),
      onClick: (r) => handleReemitir(r.id),
    },
    {
      title: 'Assinar por testemunhas',
      icon: <GroupAddIcon />,
      // Até a primeira testemunha assinar a lista pode ser refeita.
      disabled: (r) =>
        !(
          r.status === 'pendente' &&
          Boolean(r.modelo) &&
          r.modelo.acao === 'assinar' &&
          // Só enquanto o colaborador (ou uma testemunha) não assinou; as pessoas fixas
          // podem já ter assinado.
          (r.assinaturas
            ? !r.assinaturas.some((a) => a.titular && a.assinado_em)
            : !r.assinatura)
        ),
      onClick: (r) => setTestemunhasDoc(r),
    },
    {
      rotuloCurto: 'Substituir arquivo',
      // A dica explica o que a ação faz e, desabilitada, por que não dá para usar.
      title: (r) => {
        if (!r.modelo || r.modelo.origem !== 'por_colaborador') {
          return 'Substituir arquivo: só vale para documentos de "Um arquivo por colaborador"';
        }
        if (r.status !== 'pendente') {
          return 'Substituir arquivo: só vale enquanto o documento está pendente';
        }
        if (r.assinatura || (r.assinaturas || []).some((a) => a.assinado_em)) {
          return 'Já recebeu assinatura: o arquivo não pode mais ser trocado. Exclua o documento e crie outro';
        }
        return 'Trocar o arquivo deste documento por outro (PDF ou imagem). O documento continua o mesmo, só o arquivo muda';
      },
      icon: <PublishOutlinedIcon />,
      disabled: (r) =>
        !(
          r.status === 'pendente' &&
          r.modelo &&
          r.modelo.origem === 'por_colaborador' &&
          !r.assinatura &&
          !(r.assinaturas || []).some((a) => a.assinado_em)
        ),
      onClick: (r) => {
        alvoSubstituir.current = r;
        refSubstituir.current.click();
      },
    },
    {
      title: 'Cancelar',
      icon: <CancelOutlinedIcon />,
      disabled: (r) =>
        !['pendente', 'emitido', 'em_analise'].includes(r.status),
      onClick: (r) => handleCancelar(r.id),
    },
    {
      title: 'Excluir',
      icon: <DeleteOutlineIcon />,
      // Sem a permissão o botão some em todas as linhas (não desalinha a coluna).
      show: () => podeExcluir,
      disabled: (r) => r.status === 'excluido',
      onClick: (r) => handleExcluir(r.id),
    },
  ];

  const dialogos = (
    <>
      <input
        ref={refSubstituir}
        type="file"
        hidden
        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
        onChange={arquivoSubstituto}
      />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
      <DialogoDetalhes
        documento={detalhes}
        onClose={() => setDetalhes(null)}
        onVisualizarPdf={(r) => handleVisualizar(r)}
        onVisualizarArquivo={(r) => handleVisualizar(r, 'arquivo-enviado')}
      />
      <Dialog
        open={Boolean(rejeitando)}
        onClose={() => setRejeitando(null)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Rejeitar arquivo
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            O colaborador verá o motivo e poderá enviar outro arquivo.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            label="Motivo da rejeição"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            inputProps={{ maxLength: 500 }}
            style={{ marginTop: 8 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRejeitando(null)}>Voltar</Button>
          <Button
            color="primary"
            variant="contained"
            disabled={!motivo.trim()}
            onClick={rejeitar}
          >
            Rejeitar
          </Button>
        </DialogActions>
      </Dialog>
      <DialogoTestemunhas
        documento={testemunhasDoc}
        onClose={() => setTestemunhasDoc(null)}
        onSalvo={aoAtualizar}
      />
      <Dialog open={pdf.open} onClose={handleFechar} fullScreen>
        <Box
          display="flex"
          alignItems="center"
          px={2}
          py={1}
          style={{ gap: 12, backgroundColor: PRIMARY_COLOR, color: 'white' }}
        >
          <div style={{ minWidth: 0 }}>
            <Typography variant="subtitle1" noWrap style={{ fontWeight: 600 }}>
              {pdf.titulo || 'Documento'}
            </Typography>
            {pdf.data && (
              <Typography variant="caption" display="block" noWrap>
                {pdf.data}
              </Typography>
            )}
          </div>
          {pdf.selo && !celularAcoes && (
            <Chip
              icon={<VerifiedUserIcon style={{ color: '#1b5e20' }} />}
              label={pdf.selo}
              style={{
                backgroundColor: '#e8f5e9',
                color: '#1b5e20',
                fontWeight: 600,
              }}
            />
          )}
          {pdf.selo && celularAcoes && (
            <Tooltip title={pdf.selo}>
              <VerifiedUserIcon style={{ color: '#a5d6a7' }} />
            </Tooltip>
          )}
          <Box flex={1} />
          <Tooltip title="Baixar PDF">
            <IconButton
              size="small"
              onClick={baixarPdfAberto}
              style={{ color: 'white' }}
            >
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <IconButton
            size="small"
            onClick={handleFechar}
            style={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent style={{ padding: 0, display: 'flex' }}>
          {pdf.url && <VisualizadorArquivo url={pdf.url} tipo={pdf.tipo} />}
        </DialogContent>
      </Dialog>
    </>
  );

  return { acoes, dialogos };
};

// Cartão de um item no celular, estilo "pílula": título com o botão de mais ações à direita, uma
// linha com ícone + texto e uma etiqueta à direita, o corpo (`children`) e, no rodapé, as duas
// primeiras ações como botões (a primeira preta e cheia). Ação desabilitada ou escondida não
// aparece (só serve para alinhar as colunas da tabela). `rotuloCurto` da ação, se houver, é o
// texto do botão. Usado pelo cartão do documento e pelo do modelo.
export const CartaoPilula = ({
  titulo,
  icone: Icone,
  linhaTexto,
  corLinha,
  etiqueta,
  acoes,
  registro,
  children,
}) => {
  const [ancora, setAncora] = useState(null);
  const itens = acoes
    .map((acao, idx) => ({ acao, idx, ...resolverAction(acao, registro) }))
    .filter(({ show, disabled }) => show && !disabled);
  const principais = itens.slice(0, 2);
  const resto = itens.slice(2);

  return (
    <Box
      style={{
        backgroundColor: '#f6f6f6',
        border: '1px solid #d9d9d9',
        borderRadius: 18,
        padding: '16px 18px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
      }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
        <Typography
          variant="subtitle1"
          component="div"
          noWrap
          title={typeof titulo === 'string' ? titulo : undefined}
          style={{
            flex: 1,
            minWidth: 0,
            fontWeight: 700,
            color: '#111',
            lineHeight: 1.3,
          }}
        >
          {titulo}
        </Typography>
        {resto.length > 0 && (
          <>
            <IconButton
              aria-label="Mais ações"
              size="small"
              style={{
                flexShrink: 0,
                width: 36,
                height: 36,
                border: '1px solid #cfcfcf',
                color: '#333',
              }}
              onClick={(e) => setAncora(e.currentTarget)}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
              anchorEl={ancora}
              open={Boolean(ancora)}
              onClose={() => setAncora(null)}
            >
              {resto.map(({ acao, idx, iconNode, title }) => (
                <MenuItem
                  key={acao.key || idx}
                  onClick={() => {
                    setAncora(null);
                    acao.onClick(registro);
                  }}
                >
                  <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                    {iconNode}
                    {acao.rotuloCurto || title}
                  </Box>
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={0.75}
        style={{ gap: 8 }}
      >
        <Box display="flex" alignItems="center" minWidth={0} style={{ gap: 6 }}>
          {Icone && (
            <Icone
              style={{ fontSize: 16, color: corLinha || '#666', flexShrink: 0 }}
            />
          )}
          <Typography
            variant="body2"
            noWrap
            style={
              corLinha
                ? { color: corLinha, fontWeight: 600 }
                : { color: '#555' }
            }
          >
            {linhaTexto}
          </Typography>
        </Box>
        {etiqueta}
      </Box>
      {children}
      {principais.length > 0 && (
        <>
          <div style={LINHA_CARTAO} />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: principais.length === 1 ? '1fr' : '1fr 1fr',
              gap: 8,
            }}
          >
            {principais.map(({ acao, idx, iconNode, title }, posicao) => (
              <Button
                key={acao.key || idx}
                variant={posicao === 0 ? 'contained' : 'outlined'}
                startIcon={iconNode}
                onClick={() => acao.onClick(registro)}
                style={{
                  minHeight: 44,
                  minWidth: 0,
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: 'none',
                  ...(posicao === 0
                    ? { backgroundColor: '#111', color: '#fff' }
                    : { borderColor: '#cfcfcf', color: '#333' }),
                }}
              >
                {acao.rotuloCurto || title}
              </Button>
            ))}
          </div>
        </>
      )}
    </Box>
  );
};

// Linha fina que separa as partes do cartão, e rótulo pequeno em maiúsculas dos dados.
export const LINHA_CARTAO = {
  height: 1,
  backgroundColor: '#e3e3e3',
  margin: '12px 0',
};
export const ROTULO_CARTAO = {
  color: '#777',
  fontSize: '0.6875rem',
  fontWeight: 600,
  letterSpacing: 0.6,
  textTransform: 'uppercase',
};

// Mesmas cores da ação nas outras telas (etiqueta da ação).
const COR_ACAO_CARTAO = {
  assinar: '#8a4600',
  visualizar: '#6a1b9a',
  enviar_arquivo: '#01579b',
};

const ICONE_ACAO_CARTAO = {
  assinar: EditOutlinedIcon,
  visualizar: MenuBookOutlinedIcon,
  enviar_arquivo: CloudUploadOutlinedIcon,
};

// Cartão do documento no celular (a tela Documentos usa no lugar da tabela).
export const CartaoDocumento = ({ documento, acoes }) => (
  <CartaoPilula
    titulo={renderColaborador(documento)}
    icone={
      ICONE_ACAO_CARTAO[documento.modelo && documento.modelo.acao] ||
      EditOutlinedIcon
    }
    linhaTexto={(documento.modelo && textoAcao[documento.modelo.acao]) || '—'}
    corLinha={COR_ACAO_CARTAO[documento.modelo && documento.modelo.acao]}
    etiqueta={
      <span
        style={{
          flexShrink: 0,
          padding: '2px 10px',
          borderRadius: 999,
          backgroundColor: corStatus[documento.status] || '#9e9e9e',
          color: '#fff',
          fontSize: '0.75rem',
          fontWeight: 600,
          whiteSpace: 'nowrap',
        }}
      >
        {rotuloStatus(documento)}
      </span>
    }
    acoes={acoes}
    registro={documento}
  >
    {/* Sem a data da assinatura: nem a legenda "Assinado em…" nem a linha dentro da assinatura. */}
    {legendaStatus(documento) && documento.status !== 'assinado' && (
      <Typography
        variant="caption"
        display="block"
        style={{ color: '#777', marginTop: 4, textAlign: 'right' }}
      >
        {legendaStatus(documento)}
      </Typography>
    )}
    <div style={LINHA_CARTAO} />
    <Box mb={1.5}>
      <Typography variant="caption" display="block" style={ROTULO_CARTAO}>
        Modelo
      </Typography>
      <Typography
        variant="body1"
        style={{ fontWeight: 700, color: '#111', wordBreak: 'break-word' }}
      >
        {documento.modelo ? documento.modelo.nome : '—'}
      </Typography>
    </Box>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px 12px',
      }}
    >
      <div>
        <Typography variant="caption" display="block" style={ROTULO_CARTAO}>
          Competência
        </Typography>
        <Typography variant="body1" style={{ fontWeight: 700, color: '#111' }}>
          {renderCompetencia(documento)}
        </Typography>
      </div>
      <div>
        <Typography variant="caption" display="block" style={ROTULO_CARTAO}>
          Criado em
        </Typography>
        <Typography variant="body2" style={{ fontWeight: 700, color: '#111' }}>
          {renderCriadoEm(documento)}
        </Typography>
      </div>
    </div>
    <Box mt={1.5}>
      <Typography variant="caption" display="block" style={ROTULO_CARTAO}>
        Assinatura
      </Typography>
      <Typography variant="body2" component="div">
        {renderAssinatura(documento, { semData: true })}
      </Typography>
    </Box>
  </CartaoPilula>
);

// Mesmo botão azul do "Enviar documento" de Minhas pendências.
const useEstilosResumo = makeStyles({
  botao: {
    borderRadius: 8,
    backgroundColor: '#2563eb',
    color: '#fff',
    textTransform: 'none',
    height: 40,
    padding: '0 16px',
    '&:hover': { backgroundColor: '#1d4ed8' },
  },
});

const List = (props) => {
  const classesResumo = useEstilosResumo();
  const celular = useMediaQuery((tema) => tema.breakpoints.down('sm'));
  const refresh = useRefresh();
  const [totais, setTotais] = useState({});
  const [resumoAberto, setResumoAberto] = useState(false);

  // Total de cada aba (sem os demais filtros), mostrado no selo da aba.
  async function carregarPendentes() {
    try {
      const resultados = await Promise.all(
        tabs.map((tab) =>
          getListAPI('documentos', ['id', 'desc'], [1, 1], tab.filter, []),
        ),
      );
      setTotais(
        Object.fromEntries(
          tabs.map((tab, indice) => [tab.id, resultados[indice].total]),
        ),
      );
    } catch (e) {
      setTotais({});
    }
  }

  useEffect(() => {
    carregarPendentes();
  }, []);

  const { acoes, dialogos } = useAcoesDocumentos(() => {
    refresh();
    carregarPendentes();
  });

  const tabsComContador = tabs.map((tab) => ({
    ...tab,
    contador: totais[tab.id] != null ? totais[tab.id] : undefined,
  }));

  // Dentro da lista (usa o contexto dela): botão do resumo, o próprio diálogo e o
  // status inicial.
  const headerActions = (
    <>
      <StatusInicial />
      <ResumoPorModelo
        open={resumoAberto}
        onClose={() => setResumoAberto(false)}
      />
      {celular ? (
        <Tooltip title="Resumo por modelo">
          <IconButton
            aria-label="Resumo por modelo"
            className={classesResumo.botao}
            style={{ width: 40, padding: 0 }}
            onClick={() => setResumoAberto(true)}
          >
            <ViewListOutlinedIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant="contained"
          size="small"
          className={classesResumo.botao}
          startIcon={<ViewListOutlinedIcon />}
          onClick={() => setResumoAberto(true)}
        >
          Resumo por modelo
        </Button>
      )}
    </>
  );

  return (
    <ProtegerPagina
      permissao={PERMISSAO_TELA_DOCUMENTOS_LISTAR}
      mensagem="Você não tem permissão para acessar a tela de documentos."
    >
      <>
        <ListPageTabbedComBuscaPagina
          title="Documentos"
          tituloNaBarra={false}
          itemLabelPlural="documentos"
          perPage={50}
          rowsPerPageOptions={[10, 25, 50, 100]}
          modoRolagemTabela="setas"
          // Celular: cada documento vira um cartão (sem rolagem lateral).
          modoTabelaMobile="cards"
          renderCardMobile={(documento, { acoes: acoesDoCard }) => (
            <CartaoDocumento documento={documento} acoes={acoesDoCard} />
          )}
          colunasFixadasIniciais={{ colaborador: 'esquerda', acoes: 'direita' }}
          larguraFixadaEsquerda={260}
          larguraFixadaDireita={130}
          tabs={tabsComContador}
          advancedFilters={advancedFilters}
          quickFilterSource={null}
          headerActions={headerActions}
          listProps={{
            sort: { field: 'created_at', order: 'DESC' },
            filterDefaultValues: { status: 'pendente' },
            ...props,
          }}
        >
          <Datagrid>
            <FunctionField
              source="colaborador"
              label="Colaborador"
              render={renderColaborador}
              sortable={false}
            />
            <FunctionField
              source="documento"
              label="Documento"
              render={renderDocumento}
              sortable={false}
            />
            <FunctionField
              source="status"
              label="Status"
              render={renderStatusComAssinantes}
              sortable={false}
            />
            <FunctionField
              source="created_at"
              label="Criado em"
              render={renderCriadoEm}
              sortable={false}
            />
            <FunctionField
              source="competencia"
              label="Competência"
              render={renderCompetencia}
              sortable={false}
            />
            <ActionsField
              source="acoes"
              maxAcoesVisiveis={2}
              textAlign="right"
              label="Ações"
              sortable={false}
              actions={acoes}
            />
          </Datagrid>
        </ListPageTabbedComBuscaPagina>
        {dialogos}
      </>
    </ProtegerPagina>
  );
};

export default List;
